<script setup>
import { ref, watch } from 'vue'
import { getActivePinia } from 'pinia'
import { isEmpty, baseUrl } from '@/helpers'
import { useMagicKeys } from '@vueuse/core'
import AppPageView from '@/components/AppPageView.vue'
import Main from '@/views/Main.vue'
import About from '@/views/About.vue'
import IdleTimer from '@/components/IdleTimer.vue'
import { useAppFeature } from '@/features/useAppFeature'

const pages = {
  Main,
  About,
}

const keys = useMagicKeys()
const appFeature = useAppFeature()
const backgroundMusic = config.backgroundMusic
const app_restartTimeout = config.idleTimer.app_restartTimeout * 1000
const app_gotoMainTimeout = config.idleTimer.app_gotoMainTimeout * 1000

// State -----------------------------------------
const showTimer = ref(JSON.parse(config.showTimer))

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
const shortcut = isEmpty(config.showTimerToggleKeys) ? config.showTimerToggleKeys : 'Ctrl+I'
watch(keys[shortcut], (v) => {
  if (v) {
    showTimer.value = !showTimer.value
    console.debug(`%c[App] ${showTimer.value ? 'Show' : 'Hidden'} Timers ... ${shortcut}`, 'color: green')
  }
})

function onIdleTrigger_appRestart() {
  console.log('[App] onIdleTrigger_appRestart()')
  setTimeout(() => {
    location.reload()
  }, 500)
}

function onIdleTrigger_appGotoMain() {
  console.log('[App] onIdleTrigger_appGotoMain()')
  getActivePinia()._s.forEach((store) => store.$reset())
  // changePage('Main')
}

// Main ------------------------------------------
appFeature.setupAppConfig(config)

if (backgroundMusic !== '') {
  console.info(`%c[App] play audio ${backgroundMusic}`, style.info)
}

// -----------------------------------------------
</script>

<template>
  <audio v-if="backgroundMusic" :src="baseUrl(backgroundMusic)" preload loop autoplay></audio>

  <AppPageView :pages="pages" />

  <transition name="fade">
    <div v-show="showTimer" id="timer">
      <idle-timer
        v-if="app_restartTimeout > 0"
        title="App.RestartTimeout"
        color="green"
        :timeout="app_restartTimeout"
        @idle-trigger="onIdleTrigger_appRestart"
      />
      <idle-timer
        v-if="app_gotoMainTimeout > 0"
        title="App.GotoMainTimeout"
        color="green"
        :timeout="app_gotoMainTimeout"
        @idle-trigger="onIdleTrigger_appGotoMain"
      />
    </div>
  </transition>
</template>

<style scoped>
#timer {
  position: absolute;  
  left: 0;
  top: 0;
  z-index: var(--layer-5);
}
</style>
